import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';
import './ConsultationPaymentThankYou.css';
import { initializeThankYou } from '../thankYouScript.js';

const ConsultationPaymentThankYou = () => {
  useEffect(() => {
    // Add meta tags to head
    const offerMeta = document.createElement('meta');
    offerMeta.name = 'offer';
    offerMeta.content = 'Consultation';
    document.head.appendChild(offerMeta);

    // Initialize thank you tracking
    try {
      initializeThankYou();
      console.log('Thank you tracking initialized successfully');
    } catch (error) {
      console.error('Error initializing thank you tracking:', error);
    }

    // Cleanup function
    return () => {
      if (document.querySelector('meta[name="offer"]')) {
        document.querySelector('meta[name="offer"]').remove();
      }
    };
  }, []);

  return (
    <div className="consultation-payment-thank-you-container">
      <div className="thank-you-content">
        <div className="success-icon">
          💳 ✅
        </div>
        <h1>Thank You for Your Payment!</h1>
        <p>Your consultation payment has been successfully processed.</p>
        <p>We can now schedule a time for the call.</p>
        <div className="additional-resources">
          <h3>While You Wait</h3>
          <p>Explore our services and resources:</p>
          <div className="resource-links">
            <Link to="/relocation-services" className="resource-link">
              View All Services
            </Link>
            <Link to="/uae" className="resource-link">
              UAE Setup Guide
            </Link>
            <Link to="/mexico-residency" className="resource-link">
              Mexico Residency
            </Link>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ConsultationPaymentThankYou;

